import React, { useState } from "react";
import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../Common/styles/header";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import CreateTagModal from "./CreateTagModal";

type Props = {
  refreshPage: () => void;
};

const TagsHeader = ({ refreshPage }: Props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledHeader
        sx={{
          borderBottom: "1px solid #E0E3EB",
        }}
      >
        <Box sx={HeaderLeftContent}>
          <Typography variant="h2" color="text.primary">
            Tags
          </Typography>
        </Box>
        <Box sx={HeaderRightContent}>
          <Button variant="contained" startIcon={<Add />} onClick={handleOpen}>
            Add Tag
          </Button>
        </Box>
      </StyledHeader>
      {open && (
        <CreateTagModal
          open={open}
          closeModal={handleClose}
          refreshPage={refreshPage}
        />
      )}
    </>
  );
};

export default TagsHeader;
